// extracted by mini-css-extract-plugin
module.exports = {"block":"crm-c_block__-ve6G","title":"crm-c_title__ZM1pP","root":"crm-c_root__kzho1"};